module.exports = __webpack_public_path__ + "54a5fd31722f006036a4b23bc27c8038.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/foundation/orbit/right-arrow-small.png
// module id = 162
// module chunks = 0